module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-04-en.9142042a096779103556734a1eecbd19.png";